<template>
  <div class="look-sensor">
    <div class="in-crib-title">
      <div class="handle-wrapper" @click="backHistory">
        <div class="icon-font">&#xe612;</div>
        <a>返回</a>
      </div>
      <div class="in-crib-item">传感器修改</div>
      <div class="handle-wrapper" @click="handleIn">
        <div class="icon-font">&#xe606;</div>
        <a>确认</a>
      </div>
    </div>
    <div class="look-sensor-content">
      <div class="look-sensor-content-top">
        <div class="in-crib-info">
          <div class="info-left">
            <div class="info-select">
              <div class="info-select-msg">传感器ID：</div>
              <div class="info-select-msg">X：</div>
            </div>
            <div class="info-select">
              <div class="input-wrapper">
                <input disabled="true" v-model="nodeId" />
              </div>
              <div class="input-wrapper">
                <input v-model="tableItem.siteX" />
              </div>
            </div>
            <div class="info-select">
              <div class="info-select-msg">传感器类型：</div>
              <div class="info-select-msg">Y：</div>
            </div>
            <div class="info-select">
              <div class="input-wrapper">
                <input disabled="true" v-model="nodeTypeName" />
              </div>
              <div class="input-wrapper">
                <input v-model="tableItem.siteY" />
              </div>
            </div>
            <div class="info-select">
              <div class="info-select-msg">位置：</div>
              <div class="info-select-msg">Z：</div>
            </div>
            <div class="info-select">
              <LoadingTreeStack
                :moduleType="moduleType"
                :content="tableItem.name"
                :editCheckId="treeId"
                v-on:sendInfo="showDropInfo"
              ></LoadingTreeStack>
              <div class="input-wrapper">
                <input v-model="tableItem.siteZ" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img class="look-sensor-icon" src="../../../../assets/content-box.png" />
  </div>
</template>

<script>
import DropDownInput from "../../../../components/DropDownInput.vue";
import LoadingTreeStack from "../../../../components/LoadingTreeStack.vue";
// eslint-disable-next-line no-unused-vars
import {
  bathDelQualityTesting,
  delQualityTesting,
  findNodeLike,
  UpdataStackQue,
  UpdataSersor,
} from "../../../../api/maintain";
import { noEmpty } from "../../../../tools/methods";
export default {
  name: "TimeUpdateSensor",
  components: { DropDownInput, LoadingTreeStack },
  data() {
    return {
      moduleType: "",
      treeId: "",
      title: "",
      nodeId: "",
      nodeTypeName: "",
      tableItem: {
        id: "",
        nodeTypeName: "",
        name: "",
        nodeId: "",
        nodeType: "",
        siteId: "",
        siteType: "",
        siteX: "",
        siteY: "",
        siteZ: "",
      },
      page: 1,
      rows: 8,
      total: "",
      // 总页数
      Allpages: 0,
      totalData: [],
      tableData: [],
      sensorValue: [],
      show: false,
    };
  },
  created() {
    this.nodeId = this.$route.query.nodeId;
    this.moduleType=this.$route.query.moduleType;
    console.log(this.nodeId);
    this.handleSearch();
  },
  methods: {
    sendValue: function (value) {
      console.log(value);
      this.handleSearch(value);
    },
    handleSearch: function () {
      let body = {
        page: this.page,
        rows: this.rows,
        nodeId: this.nodeId,
      };
      UpdataSersor(body)
        .then((res) => {
          console.log(res);
          //  传感器类型
          this.nodeTypeName = res.data.nodeTypeName;
          this.tableItem.nodeTypeName = res.data.nodeTypeName;
          this.tableItem.name = res.data.stack;
          this.tableItem.siteX = res.data.siteX;
          this.tableItem.siteY = res.data.siteY;
          this.tableItem.siteZ = res.data.siteZ;
          this.tableItem.id = res.data.id;
          this.tableItem.nodeId = res.data.nodeId;
          this.tableItem.nodeType = res.data.nodeType;
          this.tableItem.siteId = res.data.siteId;
          this.tableItem.siteType = res.data.siteType;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    backHistory: function () {
      this.$router.go(-1);
    },
    handleIn: function () {
      this.addTable();
      console.log(this.totalData);
      let arr = [];
      this.totalData.map((data) => {
        arr.push({
          name: data.name,
          nodeId: data.nodeId,
          id: data.id,
          nodeType: data.nodeType,
          siteId: data.siteId,
          siteType: data.siteType,
          siteX: data.siteX,
          siteY: data.siteY,
          siteZ: data.siteZ,
        });
      });
      UpdataStackQue(JSON.parse(JSON.stringify(arr)))
        .then((res) => {
          console.log(res);
          this.$message({
            message: "修改成功！",
            type: "success",
            center: "true",
            duration: "1000",
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addTable: function () {
      console.log(this.tableItem);
      this.totalData.push({
        name: this.tableItem.name,
        nodeTypeName: this.tableItem.nodeTypeName,
        nodeId: this.tableItem.nodeId,
        id: this.tableItem.id,
        nodeType: this.tableItem.nodeType,
        siteId: this.tableItem.siteId,
        siteType: this.tableItem.siteType,
        siteX: this.tableItem.siteX,
        siteY: this.tableItem.siteY,
        siteZ: this.tableItem.siteZ,
      });
    },
    showDropInfo: function (data) {
      console.log(data);
      this.tableItem.name = data.name;
      this.tableItem.siteId = data.id;
      this.tableItem.siteType = data.siteType;
    },
  },
};
</script>

<style scoped>
@import "Time.css";
.page-btn input {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/page/maintain/core/timeMonitoring/timeUpdateSensor.vue